import { useNavigate } from "react-router-dom";

function RoadmapCard({ roadmap, onContinue }) {
  const navigate = useNavigate();
  return (
    <div className="roadmap-card">
      {roadmap ? (
        <>
          <div className="roadmap-header">
            <h3>{roadmap?.title}</h3>
            <span className="roadmap-status">Active</span>
          </div>

          <div className="roadmap-info">
            <p>
              <strong>Current:</strong>{" "}
              {roadmap.currentCourse?.type === "course"
                ? roadmap.currentCourse?.courseId?.title || "Course"
                : roadmap.currentCourse?.type === "project"
                ? "Project"
                : "Completed 🎉"}
            </p>
            <p>
                <strong>Next Milestone:</strong>{" "}
                {roadmap.currentCourse?.type
                ? "Continue Leanring"
                : "All milestones completed"}
            </p>
          </div>

          <div className="roadmap-actions">
            <button
              className="btn-primary"
              onClick={onContinue}
            >
              Continue Learning
            </button>

            <button
              className="btn-secondary"
              onClick={() => navigate("/roadmaps")}
            >
              View Roadmaps
            </button>
          </div>
        </>
      ) : (
        <>
          <h3>No Roadmap Yet</h3>
          <p>Create a structured learning path for your goals.</p>

          <div className="roadmap-actions">
            <button
              className="btn-primary"
              onClick={() => navigate("/roadmap/create")}
            >
              Create Roadmap
            </button>

            <button
              className="btn-secondary"
              onClick={() => navigate("/roadmaps")}
            >
              View Roadmaps
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default RoadmapCard;